import { useEffect } from 'react'

function CustomEvent(event, params) {
  params = params || { bubbles: false, cancelable: false, detail: undefined }
  const evt = document.createEvent('CustomEvent')
  evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail)
  return evt
}

const EventPolyfill = () => {
  useEffect(() => {
    if (typeof window.CustomEvent !== 'function') {
      CustomEvent.prototype = window.Event.prototype
      window.Event = CustomEvent
    }
  }, [])

  return null
}

export default EventPolyfill
